module.exports = __webpack_public_path__ + "media/images/portugal_center-c0466ebca2cc96a4601c8abd533395ad.jpg";